module.exports = __webpack_public_path__ + "static/field-3x-1c4f0da2de0efa623fb076e83e89d608.webp";